// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"Avatar_avatarWrapper__AbY44"};